import { render, staticRenderFns } from "./MainLedgerLLAKartica.vue?vue&type=template&id=4d452a37&scoped=true"
import script from "./MainLedgerLLAKartica.vue?vue&type=script&lang=js"
export * from "./MainLedgerLLAKartica.vue?vue&type=script&lang=js"
import style0 from "./MainLedgerLLAKartica.vue?vue&type=style&index=0&id=4d452a37&prod&scoped=true&lang=css"
import style1 from "./MainLedgerLLAKartica.vue?vue&type=style&index=1&id=4d452a37&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d452a37",
  null
  
)

export default component.exports